import { Nav } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import FeatherIcon from 'feather-icons-react'
import { sendVisitLog } from 'helpers/visitLogger'
import { colors } from '../../styles/colors'

type MenuProps = {
    showDownload?: boolean
    navClass?: string
    buttonClass?: string
    loggedInUser?: {}
    BlogPage?: boolean
}

const Menu1 = ({ navClass, showDownload, loggedInUser }: MenuProps) => {
    const location = useLocation()
    console.log("Menu1 rendered");
    const isActive = (path: string) => {
        if (path === "/") return location.pathname === "/"
        if (path === "/blogs") {
            return (
                location.pathname === "/blogs" ||
                location.pathname.startsWith("/blog/")
            )
        }
        return location.pathname.startsWith(path)
    }

    return (
        <Nav
            className={classNames(
                "flex flex-col lg:flex-row items-start lg:items-center gap-4 lg:gap-6 ml-auto",
                navClass
            )}
        >
            <Link
                to="/"
                className={classNames(
                    "text-gray-700 hover:text-teal-600 font-medium",
                    { "text-teal-600": isActive("/") }
                )}
                onClick={() => sendVisitLog("/")}
            >
                Home
            </Link>

            <Link
                to="/features"
                className={classNames(
                    "text-gray-700 hover:text-teal-600 font-medium",
                    { "text-teal-600": isActive("/features") }
                )}
            >
                Features
            </Link>

            <Link
                to="/about"
                className={classNames(
                    "text-gray-700 hover:text-teal-600 font-medium",
                    { "text-teal-600": isActive("/about") }
                )}
            >
                About
            </Link>

            <Link
                to="/contact"
                className={classNames(
                    "text-gray-700 hover:text-teal-600 font-medium",
                    { "text-teal-600": isActive("/contact") }
                )}
            >
                Contact
            </Link>

            <Link
                to="/blogs"
                className={classNames(
                    "text-gray-700 hover:text-teal-600 font-medium",
                    { "text-teal-600": isActive("/blogs") }
                )}
            >
                Blogs
            </Link>

            {showDownload && (
                <>
                    <Link
                        to="/contact"
                        className="ml-2 px-5 py-2 rounded-full text-white font-medium transition"
                        style={{ backgroundColor: colors.primary.teal1 }}
                    >
                        Book a Demo
                    </Link>

                    <a
                        href="tel:+447775168068"
                        className="flex items-center gap-2 text-gray-700 font-semibold"
                    >
                        <FeatherIcon icon="phone" size={16} />
                        +44 7775 168068
                    </a>
                </>
            )}
        </Nav>
    )
}

export default Menu1